// Redux
import { RootState } from 'src/store/rootReducer';
import { connect, ConnectedProps } from 'react-redux';
import { setPolicyMenuUnderstood } from 'src/store/notification/actions';
// Models
import { RequestIndicatorTypes } from 'data-layer-cr/dist/models';
// Components
import { InformationPopper } from 'src/components/General';
import MenuButtonContent from './MenuButtonContent';

export function shouldShowQuotationMenuPopper(
  quotationId: number,
  policyId: number,
  filterUnderstood: boolean,
  policyMenuUnderstood: boolean,
): boolean {
  if (!filterUnderstood) {
    return false;
  }
  if (policyMenuUnderstood) {
    return false;
  }
  return quotationId === policyId;
}

export const QuotationMenuButton = ({
  onModificateVin,
  quotationId,
  filterUnderstood,
  lastQuotationPolicy,
  policyMenuUnderstood,
  setPolicyMenuUnderstoodAction,
  onShowDocuments,
  onCopyQuotation,
  downloadDocumentStatus,
  showVinOption,
  menuDownloadStarted,
  isEmitted,
}: Props): JSX.Element => {
  const openPopper = shouldShowQuotationMenuPopper(
    quotationId,
    lastQuotationPolicy,
    filterUnderstood,
    policyMenuUnderstood,
  );

  return (
    <InformationPopper
      data-testid="quotation-menu-button-popper"
      title="Detalle de pólizas y cotizaciones"
      information="Encuentra aquí documentos de la póliza emitida e historial de cotizaciones en proceso."
      onUnderstood={setPolicyMenuUnderstoodAction}
      open={openPopper}
      rightContentAlign={10}
      leftArrowAlign={0}
    >
      <MenuButtonContent
        onModificateVin={onModificateVin}
        onShowDocuments={onShowDocuments}
        quotationId={quotationId}
        onCopyQuotation={onCopyQuotation}
        disableDownload={
          menuDownloadStarted || downloadDocumentStatus === 'requesting'
        }
        showVinOption={showVinOption}
        isEmitted={isEmitted}
      />
    </InformationPopper>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  filterUnderstood: boolean;
  policyMenuUnderstood: boolean;
  lastQuotationPolicy: number;
  downloadDocumentStatus: RequestIndicatorTypes;
  menuDownloadStarted: boolean;
} => ({
  filterUnderstood: state.notification.filterUnderstood,
  policyMenuUnderstood: state.notification.policyMenuUnderstood,
  lastQuotationPolicy: state.notification.lastQuotationPolicy,
  downloadDocumentStatus: state.policy.downloadStatus,
  menuDownloadStarted: state.policy.menuDownloadStarted,
});

const reduxActions = {
  setPolicyMenuUnderstoodAction: setPolicyMenuUnderstood,
};

const connector = connect(mapStateToProps, reduxActions);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
  onModificateVin: () => void;
  onShowDocuments: () => void;
  onCopyQuotation: () => void;
  quotationId: number;
  showVinOption: boolean;
  isEmitted: boolean;
}

export default connector(QuotationMenuButton);
